(function () {
  const menuToggle = document.querySelector('[data-adpt-menu-toggle]');
  const menu = document.getElementById('AdptMenu');
  if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => {
      menu.hidden = !menu.hidden;
      menuToggle.setAttribute('aria-expanded', String(!menu.hidden));
    });
  }

  const back = document.querySelector('[data-adpt-back]');
  if (back) {
    back.addEventListener('click', (event) => {
      if (document.referrer.startsWith(window.location.origin) && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  }

  // password page signup: keep the phone number on the customer as a tag too,
  // since the signup form only guarantees the email is stored
  const signup = document.querySelector('[data-adpt-signup-form]');
  if (signup) {
    signup.addEventListener('submit', () => {
      const phone = signup.querySelector('[data-adpt-signup-phone-input]');
      const tags = signup.querySelector('[data-adpt-signup-tags]');
      const digits = phone ? phone.value.replace(/[^0-9+]/g, '') : '';
      if (tags && digits) tags.value = `${tags.value},phone ${digits}`;
    });
  }

  // password page signup: ask for the email first, then the phone number
  const emailStep = document.querySelector('[data-adpt-signup-email]');
  const phoneStep = document.querySelector('[data-adpt-signup-phone]');
  if (emailStep && phoneStep) {
    const email = emailStep.querySelector('input');
    const showPhone = () => {
      if (!email.reportValidity()) return;
      emailStep.hidden = true;
      phoneStep.hidden = false;
      phoneStep.querySelector('input').focus();
    };
    emailStep.querySelector('[data-adpt-signup-next]').addEventListener('click', showPhone);
    // keep Enter in the email field from submitting before the phone step
    email.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      showPhone();
    });
  }

  // email popup: shown until the visitor closes it or signs up
  const popup = document.querySelector('[data-adpt-popup]');
  if (popup) {
    const key = 'adptPopupSeen';
    const remember = () => {
      try {
        window.localStorage.setItem(key, '1');
      } catch (error) {
        // storage can be blocked; the popup then shows again next visit
      }
    };
    let seen = false;
    try {
      seen = window.localStorage.getItem(key) === '1';
    } catch (error) {
      seen = false;
    }
    const signedUp = popup.querySelector('[data-adpt-popup-success]');
    const failed = popup.querySelector('[data-adpt-popup-error]');
    if (signedUp) remember();
    if (signedUp || failed || !seen) popup.hidden = false;
    popup.querySelector('[data-adpt-popup-close]').addEventListener('click', () => {
      popup.hidden = true;
      remember();
    });
  }

  // 360 viewer: steps through a set of photos taken around the model
  const spin = document.querySelector('[data-adpt-spin]');
  if (spin) {
    const stage = spin.querySelector('[data-adpt-spin-stage]');
    const image = spin.querySelector('[data-adpt-spin-image]');
    const slider = spin.querySelector('[data-adpt-spin-slider]');
    const auto = spin.querySelector('[data-adpt-spin-auto]');
    const zoom = spin.querySelector('[data-adpt-spin-zoom]');
    const colors = spin.querySelectorAll('[data-adpt-spin-color]');
    const views = ['Front', 'Front right', 'Right', 'Back right', 'Back', 'Back left', 'Left', 'Front left'];
    let frames = colors[0].dataset.frames.split('|');
    let productUrl = colors[0].dataset.productUrl;
    let current = 0;
    let timer = null;

    const preload = (urls) => urls.forEach((url) => (new Image().src = url));
    const show = (index) => {
      current = ((index % frames.length) + frames.length) % frames.length;
      image.src = frames[current];
      slider.value = current;
      const degrees = String(Math.round((360 / frames.length) * current)).padStart(3, '0');
      image.alt = `${degrees}\u00b0 ${views[current] || ''}`;
    };
    const stopAuto = () => {
      window.clearInterval(timer);
      timer = null;
      auto.setAttribute('aria-pressed', 'false');
    };

    preload(frames);

    let dragStart = null;
    let dragFrame = 0;
    let dragged = false;
    stage.addEventListener('pointerdown', (event) => {
      stopAuto();
      dragStart = event.clientX;
      dragFrame = current;
      dragged = false;
      stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointermove', (event) => {
      if (dragStart === null) return;
      if (Math.abs(event.clientX - dragStart) > 6) dragged = true;
      const stepWidth = stage.clientWidth / frames.length;
      show(dragFrame - Math.round((event.clientX - dragStart) / stepWidth));
    });
    stage.addEventListener('pointercancel', () => (dragStart = null));
    // a press without a drag opens the product for the colour on show
    stage.addEventListener('pointerup', () => {
      const pressed = dragStart !== null && !dragged;
      dragStart = null;
      if (pressed && productUrl) openQuick(productUrl);
    });

    slider.addEventListener('input', () => {
      stopAuto();
      show(Number(slider.value));
    });
    spin.addEventListener('keydown', (event) => {
      if (event.target === slider) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      stopAuto();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    auto.addEventListener('click', () => {
      if (timer) return stopAuto();
      auto.setAttribute('aria-pressed', 'true');
      timer = window.setInterval(() => show(current + 1), 450);
    });
    zoom.addEventListener('click', () => {
      zoom.setAttribute('aria-pressed', String(spin.classList.toggle('is-zoomed')));
    });
    spin.querySelector('[data-adpt-spin-reset]').addEventListener('click', () => {
      stopAuto();
      spin.classList.remove('is-zoomed');
      zoom.setAttribute('aria-pressed', 'false');
      show(0);
    });
    colors.forEach((button) => {
      button.addEventListener('click', () => {
        colors.forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
        frames = button.dataset.frames.split('|');
        productUrl = button.dataset.productUrl;
        preload(frames);
        show(current);
      });
    });
  }

  const initProduct = (product) => {
    const track = product.querySelector('[data-adpt-track]');
    const dots = product.querySelectorAll('[data-adpt-dot]');
    const step = (direction) => track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    product.querySelector('[data-adpt-prev]')?.addEventListener('click', () => step(-1));
    product.querySelector('[data-adpt-next]')?.addEventListener('click', () => step(1));
    track.addEventListener('scroll', () => {
      const current = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === current));
    });
  };
  document.querySelectorAll('[data-adpt-product]').forEach(initProduct);

  // product pop-up: loads the product section over the current page
  let quick = null;
  const openQuick = (url) => {
    if (!quick) {
      quick = document.createElement('dialog');
      quick.className = 'adpt-quick';
      quick.innerHTML =
        '<button type="button" class="adpt-icon-btn adpt-quick__close" aria-label="Close">' +
        '<svg class="adpt-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
        '</button><div data-adpt-quick-content></div>';
      quick.querySelector('.adpt-quick__close').addEventListener('click', () => quick.close());
      document.body.appendChild(quick);
    }
    const sectionUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=adpt-product`;
    fetch(sectionUrl)
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
      .then((html) => {
        const content = quick.querySelector('[data-adpt-quick-content]');
        content.innerHTML = html;
        const product = content.querySelector('[data-adpt-product]');
        if (!product) throw new Error('product section missing');
        initProduct(product);
        if (!quick.open) quick.showModal();
      })
      .catch(() => {
        window.location.href = url;
      });
  };
  // product grid: photos come with different amounts of empty space around the garment,
  // so find the garment in each one and scale it to fill the same share of its frame
  const fitGarment = (image) => {
    const sample = 160;
    const canvas = document.createElement('canvas');
    canvas.width = sample;
    canvas.height = sample;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    let pixels;
    try {
      context.drawImage(image, 0, 0, sample, sample);
      pixels = context.getImageData(0, 0, sample, sample).data;
    } catch (error) {
      return;
    }
    const background = [pixels[0], pixels[1], pixels[2], pixels[3]];
    let left = sample;
    let top = sample;
    let right = -1;
    let bottom = -1;
    for (let y = 0; y < sample; y += 1) {
      for (let x = 0; x < sample; x += 1) {
        const i = (y * sample + x) * 4;
        const differs =
          background[3] < 16
            ? pixels[i + 3] > 40
            : Math.abs(pixels[i] - background[0]) + Math.abs(pixels[i + 1] - background[1]) + Math.abs(pixels[i + 2] - background[2]) > 60;
        if (!differs) continue;
        if (x < left) left = x;
        if (x > right) right = x;
        if (y < top) top = y;
        if (y > bottom) bottom = y;
      }
    }
    if (right < left || bottom < top) return;

    // the photo sits "contained" in a square frame; work in fractions of that frame
    const { naturalWidth: width, naturalHeight: height } = image;
    const longest = Math.max(width, height);
    const shownWidth = width / longest;
    const shownHeight = height / longest;
    const boxWidth = ((right - left + 1) / sample) * shownWidth;
    const boxHeight = ((bottom - top + 1) / sample) * shownHeight;
    const centerX = (1 - shownWidth) / 2 + ((left + right + 1) / 2 / sample) * shownWidth;
    const centerY = (1 - shownHeight) / 2 + ((top + bottom + 1) / 2 / sample) * shownHeight;
    const scale = Math.min(0.92 / Math.max(boxWidth, boxHeight), 4);
    const moveX = -scale * (centerX - 0.5) * 100;
    const moveY = -scale * (centerY - 0.5) * 100;
    image.style.transform = `translate(${moveX}%, ${moveY}%) scale(${scale})`;
  };
  document.querySelectorAll('.adpt-grid__media img').forEach((image) => {
    if (image.complete && image.naturalWidth > 0) {
      fitGarment(image);
    } else {
      image.addEventListener('load', () => fitGarment(image), { once: true });
    }
  });

  // community page: plan filters and the two-step interest form
  const club = document.querySelector('[data-adpt-club]');
  if (club) {
    const filters = club.querySelectorAll('[data-adpt-club-filter]');
    filters.forEach((button) => {
      button.addEventListener('click', () => {
        filters.forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
        club.querySelectorAll('[data-adpt-club-card]').forEach((card) => {
          card.hidden = button.dataset.adptClubFilter !== '' && card.dataset.category !== button.dataset.adptClubFilter;
        });
      });
    });

    const next = club.querySelector('[data-adpt-club-continue]');
    if (next) {
      const form = next.closest('form');
      form.classList.add('is-stepped');
      const goTo = (step) => {
        form.dataset.step = step;
        club.querySelector('[data-adpt-club-progress]').textContent = `0${step} / 02`;
        club.querySelector('[data-adpt-club-bar]').style.width = `${step * 50}%`;
      };
      goTo(form.querySelector('.adpt-club__form-error') ? 2 : 1);
      next.addEventListener('click', () => {
        const picked = [...form.querySelectorAll('[data-adpt-club-choice]:checked')].map((choice) => choice.value);
        form.querySelector('[data-adpt-club-tags]').value = ['community', ...picked].join(',');
        goTo(2);
        form.querySelector('input[type="email"]').focus();
      });
    }
  }

  // side cart: adds without leaving the page, then slides the cart in from the right
  const routes = window.routes || {};
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let drawer = null;
  const openDrawer = () =>
    fetch(`${rootUrl}?section_id=adpt-cart-drawer`)
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
      .then((html) => {
        if (!drawer) {
          drawer = document.createElement('dialog');
          drawer.className = 'adpt-drawer';
          drawer.addEventListener('click', (event) => {
            if (event.target === drawer || event.target.closest('[data-adpt-drawer-close]')) drawer.close();
          });
          document.body.appendChild(drawer);
        }
        drawer.innerHTML = html;
        const inner = drawer.querySelector('[data-adpt-cart-count]');
        if (!inner) throw new Error('cart drawer missing');
        const count = Number(inner.dataset.adptCartCount);
        document.querySelectorAll('.adpt-header__cart').forEach((link) => {
          let badge = link.querySelector('.adpt-header__count');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'adpt-header__count';
            link.prepend(badge);
          }
          badge.textContent = count > 0 ? count : '';
        });
        if (!drawer.open) drawer.showModal();
      });
  const cartFallback = () => {
    window.location.href = routes.cart_url || '/cart';
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form.adpt-product__buy');
    if (!form || typeof HTMLDialogElement === 'undefined') return;
    event.preventDefault();
    fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error(response.status))))
      .then(() => {
        if (quick && quick.open) quick.close();
        return openDrawer();
      })
      .catch(() => form.submit());
  });

  document.addEventListener('click', (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    if (typeof HTMLDialogElement === 'undefined') return;
    const change = event.target.closest('.adpt-drawer [data-adpt-cart-change]');
    if (change) {
      event.preventDefault();
      fetch(`${routes.cart_change_url || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(change.dataset.line), quantity: Number(change.dataset.quantity) }),
      })
        .then((response) => (response.ok ? openDrawer() : Promise.reject(new Error(response.status))))
        .catch(cartFallback);
      return;
    }
    if (event.target.closest('[data-adpt-cart-open]')) {
      event.preventDefault();
      openDrawer().catch(cartFallback);
    }
  });

  // colour menu: each colour is its own product
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-adpt-color-select]');
    if (!select) return;
    if (select.closest('.adpt-quick')) {
      openQuick(select.value);
    } else {
      window.location.href = select.value;
    }
  });
  document.addEventListener('click', (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    const link = event.target.closest('[data-adpt-quick], .adpt-quick [data-adpt-color]');
    if (!link || typeof HTMLDialogElement === 'undefined') return;
    event.preventDefault();
    openQuick(link.href);
  });
})();
